import React, { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { Card, Box, Container, CardContent } from "@mui/material";
import { Grid } from "@mui/material";
import TextField from "@mui/material/TextField";

export default function NewEditForm() {
  const [instancecutomize, setinstancecutomize] = useState([]);

  useEffect(() => {
    const InstanceID = localStorage.getItem("InstanceID");
    fetch(`${process.env.REACT_APP_API_URL}/api/labcustomize/${InstanceID}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((resp) => setinstancecutomize(resp))
      .catch((error) => {
        console.error(error);
      });
  }, []);
  
  const [template, settemplate] = React.useState([[]]);
  const application = localStorage.getItem("Application");
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/templateview/${application}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((resp) => settemplate(resp))
      .catch((error) => {
        console.error(error);
      });
  }, [application]);

  
  const [instancetype, setInstancetype] = React.useState([[]]);
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/instancetype/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((resp) => setInstancetype(resp))
      .catch((error) => {
        console.error(error);
      });
  }, []);

  const handleChange = (e, key) => {
    const { id, value } = e.target;
    if (key === "port") {
      setinstancecutomize((prevState) => ({
        ...prevState,
        [id]: [value],
      }));
    } else {
      setinstancecutomize((prevState) => ({
        ...prevState,
        [id]: value,
      }));
    }
  };

  const renderFields = (template) => {
    return template.map((field) => {
      let { key, title, type, name, description } = field;
      switch (type) {
        case "text":
          return (
            <Grid item md={6} xs={12} key={name}>
              <Typography variant="h7" gutterBottom>
                {title}
              </Typography>
              <TextField
                fullWidth
                helperText={description}
                name={name}
                id={name}
                type={type}
                onChange={(event) => handleChange(event, key)}
                required
                value={instancecutomize[name]}
                variant="outlined"
              />
            </Grid>
          );
        case "select":
          return (
            <React.Fragment>
              {key === "type" ? (
                <Grid item md={6} xs={12} key={name}>
                  <Typography variant="h7" gutterBottom>
                    {title}
                  </Typography>
                  <TextField
                    fullWidth
                    helperText={description}
                    name={name}
                    id={name}
                    onChange={(event) => handleChange(event, key)}
                    value={instancecutomize[name]}
                    required
                    select
                    SelectProps={{ native: true }}
                    variant="outlined"
                  >
                    <option key="" value=""></option>
                    {instancetype.map((instancetype) => {
                      return (
                        <React.Fragment>
                          <option value={instancetype.instance_type}>
                            {instancetype.instance_type}
                          </option>
                        </React.Fragment>
                      );
                    })}
                  </TextField>
                </Grid>
              ) : (
                ""
              )}
            </React.Fragment>
          );
        default:
          return (
            <div key={name}>
              <span className="red-text">
                {name} {type}
              </span>
            </div>
          );
      }
    });
  };
  const DetailedInsatnce = () => {
    window.location.href = "/app/instanceedit";
  };
  const handleSubmitClick = (e) => {
    e.preventDefault();
    DetailedInsatnce();
    const statevar = JSON.stringify(instancecutomize);
    const Jsonreplace = statevar.replace(/"]/g, "]").replace(/\["/g, "[");
    const value = {
      customized_variable: Jsonreplace,
    };
    
    const InstanceID = localStorage.getItem("InstanceID");
    fetch(
      `${process.env.REACT_APP_API_URL}/api/manageInstance/${InstanceID}/`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
        body: JSON.stringify(value),
      }
    )
      .then((response) => response.json())
      .then((data) => {})
      .catch((error) => {
        console.error(error);
      });
  };

  return (
    <React.Fragment>
      <Box
        sx={{
          minWidth: "1050",
          paddingRight: "40px",
        }}
      >
        <Typography component="h4" variant="h5" align="center">
          Edit the Lab configuration
        </Typography>
      </Box>
      <Box
        sx={{
          minWidth: "1050",
          paddingRight: "40px",
        }}
      >
        <Container maxWidth={false}>
          <Box sx={{ pt: 3 }}>
            <Card
              sx={{
                display: "flex",
                flexDirection: "column",
                height: "100%",
                minWidth: "1050",
              }}
            >
              <CardContent>
                <form
                  autoComplete="off"
                  noValidate
                  style={{ paddingRight: "40px", paddingLeft: "20px" }}
                >
                  <Box sx={{ pb: 2 }}></Box>
                  <Grid container spacing={3}>
                    {renderFields(template)}
                  </Grid>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "flex-end",
                      pt: 2,
                    }}
                  >
                    <div style={{ paddingRight: "10px" }}>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={DetailedInsatnce}
                      >
                        Cancel
                      </Button>
                    </div>
                    <div>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={handleSubmitClick}
                      >
                        Update
                      </Button>
                    </div>
                  </Box>
                </form>
              </CardContent>
            </Card>
          </Box>
        </Container>
      </Box>
    </React.Fragment>
  );
}
